module.exports = __webpack_public_path__ + "img/kommune-1839.0cb78cdf.svg";